export enum TenantTableNames {
  'Contacts' = 'Contacts',
}
